import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewEncapsulation} from '@angular/core';
import {MenuGruppe, MenuSeite} from '../../../models/menuState';
import {flatMap, UIArtefakt, UIArtefaktGruppe, UiInputControl, UIMenu, UIMenuSeite, uniqueKey} from '../../../models/uiArtefakt';
import {UIDarstellungsart} from '../../../models/uiDarstellungsart';
import {ShellConfigService} from '../../../services/shell-config.service';
import {UILayout} from '../../../models/uiLayout';
import {EventService} from '../../../services/event.service';
import {Observable, Subscription, tap} from 'rxjs';
import {filter, map, withLatestFrom} from 'rxjs/operators';

@Component({
    selector: 'lv-accordion-view',
    templateUrl: './accordion-view.component.html',
    styleUrls: ['./accordion-view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AccordionViewComponent implements OnInit, OnDestroy, AfterViewInit  {
  @Input()
  public menu: UIMenu;
  @Input()
  public uiLayout: UILayout;
  @Input()
  public uiArtefakt: UIArtefaktGruppe;

  public uiDarstellungsart = UIDarstellungsart;
  public uiLayoutEnum = UILayout;
  public showWorkflowButtons: boolean;
  public selectedMenuItem$: Observable<string>;
  public uiControlsRequestPending: boolean;
  public clickedButton: string;
  public hasPflichtfelder: Map<string, boolean> = new Map<string, boolean>();

  private _uiControlsRequestPendingSubscription$ = Subscription.EMPTY;
  private _menuItemSelectedSubscription$ = Subscription.EMPTY;

  constructor(private _shellConfigService: ShellConfigService,
              private _eventService: EventService, private _renderer: Renderer2, private _element: ElementRef) {}

  ngAfterViewInit(): void {
    if (!!this.uiArtefakt) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    }
  }

  ngOnInit(): void {
    this.showWorkflowButtons = this._shellConfigService.shellParameter.showWorkflowButtons;
    this.selectedMenuItem$ = this._eventService.menuItemSelected$.asObservable();
    this._menuItemSelectedSubscription$ = this._eventService.menuItemSelected$.pipe(tap(_ => this.clickedButton = void 0)).subscribe();
    this._uiControlsRequestPendingSubscription$ = this._eventService.uiControlsRequestPending$
    .subscribe(requestPending => this.uiControlsRequestPending = requestPending);
    this._hasPflichtfelder();
  }

  ngOnDestroy(): void {
    if (!!this._menuItemSelectedSubscription$) {
      this._menuItemSelectedSubscription$.unsubscribe();
    }
    if (!!this._uiControlsRequestPendingSubscription$) {
      this._uiControlsRequestPendingSubscription$.unsubscribe();
    }
  }

  public onZurueckClicked() {
    this.clickedButton = 'zurueck';
    this._eventService.zurueckButtonClicked$.next();
  }

  public onWeiterClicked() {
    this.clickedButton = 'weiter';
    this._eventService.weiterButtonClicked$.next();
  }

  public onSectionSelected(section: string) {
    this._eventService.menuItemRequested$.next(section);
  }

  public trackBySeite(item: MenuSeite) {
    return item.Identifikator;
  }

  public trackByGruppe(item: MenuGruppe) {
    return item.Identifikator;
  }

  public trackByFn(index: number, item: UIArtefakt) {
    return uniqueKey(item);
  }

  private _hasPflichtfelder() {
    if (!!this.menu.UIMenuGruppen) {
      this.menu.UIMenuGruppen.forEach(gruppe => {
        this.hasPflichtfelder.set(gruppe.Identifikator, false);
        gruppe.UIMenuSeiten.forEach(seite => {
          const pflichtFelder = flatMap(seite.UIArtefakt).map(artefakt => artefakt as UiInputControl)
          .filter(artefakt => !!artefakt.PflichtfeldJN && artefakt.PflichtfeldJN).length;
          if (pflichtFelder > 0) {
            this.hasPflichtfelder.set(seite.Identifikator, true);
            this.hasPflichtfelder.set(gruppe.Identifikator, true);
          } else {
            this.hasPflichtfelder.set(seite.Identifikator, false);
          }
        });
      });
    }
  }
}
